import { useQuery } from '@tanstack/react-query'
import { useApi } from '@renderer/chat/api'
import { slackArtifactResponseSchema, type SlackDirectory } from './slack-share'

/**
 * The signed-in user's Slack channels and teammates, from the gateway's workspace artifact (cached
 * there for up to a day). Null when the gateway has no artifact for the connection.
 */
export function useSlackDirectory(enabled: boolean) {
  const { get } = useApi()

  return useQuery({
    queryKey: ['connections-artifact', 'json', 'slack'],
    queryFn: async (): Promise<SlackDirectory | null> => {
      const response = await get('connections-artifacts/json/slack', { version: 'v1' })
      if (response.status === 404) {
        return null
      }
      if (!response.ok) {
        throw new Error(`Slack workspace request failed (${response.status})`)
      }
      return slackArtifactResponseSchema.parse(await response.json()).data.artifactData
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
